import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router } from "react-router-dom";
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import './Scripts/pixelFB';
import { fbq, initializeFacebookPixel } from './Scripts/pixelFB';
import { storeData } from './storeData';
import { initializeFSTORE } from './Scripts/initializeFSTORE';
import { initializeFSTORE2 } from './Scripts/initializeFSTORE2';
import { initializePinterestPixel } from './Scripts/pixelPT';
const db = initializeFSTORE();
const store_db = initializeFSTORE2();

// console.log(fbq)

(async function setup() {
  let store_data_obj = await storeData(true, store_db);
  const ID_DE_PIXEL = store_data_obj.facebook_pixel_id
  
  if(ID_DE_PIXEL === undefined || ID_DE_PIXEL === null){
    let WITOUT_PIXEL = "WITOUT_PIXEL"
    await initializeFacebookPixel(WITOUT_PIXEL);
  } else {
    await initializeFacebookPixel(ID_DE_PIXEL);
  }

  const ID_DE_PIXEL_PT = store_data_obj.pinterest_pixel_id
  if(ID_DE_PIXEL_PT === undefined || ID_DE_PIXEL_PT === null){
    let WITOUT_PIXEL_PT = "WITOUT_PIXEL"
    await initializePinterestPixel(WITOUT_PIXEL_PT);
  } else {
    await initializePinterestPixel(ID_DE_PIXEL_PT);
  }

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <Router>
      <App db={db}/>
    </Router>
  );
})();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

